import Item from '@/models/Item';
import { AxiosError } from 'axios';
import { ContentEnrollment } from '../content/types';

export enum ItemTypes {
    GET_ITEMS_CLEAR = '@item/GET_ITEMS_CLEAR',
    POST_ITEM_CLEAR = '@item/POST_ITEM_CLEAR',
    PUT_ITEM_CLEAR = '@item/PUT_ITEM_CLEAR',
    DELETE_ITEM_CLEAR = '@item/DELETE_ITEM_CLEAR',
    PUBLISH_ITEM_CLEAR = '@item/PUBLISH_ITEM_CLEAR',
    ARCHIVE_ITEM_CLEAR = '@item/ARCHIVE_ITEM_CLEAR',
    GET_ITEM_REQUEST = '@item/GET_ITEM_REQUEST',
    GET_ITEM_SUCCESS = '@item/GET_ITEM_SUCCESS',
    GET_ITEM_PATH_SUCCESS = '@item/GET_ITEM_PATH_SUCCESS',
    GET_ITEM_FAILURE = '@item/GET_ITEM_FAILURE',
    GET_ITEMS_REQUEST = '@item/GET_ITEMS_REQUEST',
    GET_ITEMS_SUCCESS = '@item/GET_ITEMS_SUCCESS',
    GET_ITEMS_FAILURE = '@item/GET_ITEMS_FAILURE',
    POST_ITEM_REQUEST = '@item/POST_ITEM_REQUEST',
    POST_ITEM_SUCCESS = '@item/POST_ITEM_SUCCESS',
    POST_ITEM_FAILURE = '@item/POST_ITEM_FAILURE',
    PUT_ITEM_REQUEST = '@item/PUT_ITEM_REQUEST',
    PUT_ITEM_SUCCESS = '@item/PUT_ITEM_SUCCESS',
    PUT_ITEM_FAILURE = '@item/PUT_ITEM_FAILURE',
    DELETE_ITEM_REQUEST = '@itemDELETE_ITEM_REQUEST',
    DELETE_ITEM_SUCCESS = '@itemDELETE_ITEM_SUCCESS',
    DELETE_ITEM_FAILURE = '@itemDELETE_ITEM_FAILURE',
    PUBLISH_ITEM_REQUEST = '@item/PUBLISH_ITEM_REQUEST',
    PUBLISH_ITEM_SUCCESS = '@item/PUBLISH_ITEM_SUCCESS',
    PUBLISH_ITEM_FAILURE = '@item/PUBLISH_ITEM_FAILURE',
    ARCHIVE_ITEM_REQUEST = '@item/ARCHIVE_ITEM_REQUEST',
    ARCHIVE_ITEM_SUCCESS = '@item/ARCHIVE_ITEM_SUCCESS',
    ARCHIVE_ITEM_FAILURE = '@item/ARCHIVE_ITEM_FAILURE',
    GET_CONTENT_LIST_REQUEST = '@content/GET_CONTENT_LIST_REQUEST',
    GET_CONTENT_LIST_FAILURE = '@content/GET_CONTENT_LIST_FAILURE',
    GET_CONTENT_REQUEST = '@content/GET_CONTENT_REQUEST',
    GET_CONTENT_SUCCESS = '@content/GET_CONTENT_SUCCESS',
    GET_CONTENT_FAILURE = '@content/GET_CONTENT_FAILURE',
    START_CONTENT_REQUEST = '@content/START_CONTENT_REQUEST',
    START_CONTENT_SUCCESS = '@content/START_CONTENT_SUCCESS',
    START_CONTENT_FAILURE = '@content/START_CONTENT_FAILURE',
    FINISH_CONTENT_REQUEST = '@content/FINISH_CONTENT_REQUEST',
    FINISH_CONTENT_SUCCESS = '@content/FINISH_CONTENT_SUCCESS',
    FINISH_CONTENT_FAILURE = '@content/FINISH_CONTENT_FAILURE',
    CLEAR_CURRENT_CONTENT_STUDENT_VIEW_FROM_LIST_IN_PROGRESS = '@content/CLEAR_CURRENT_CONTENT_STUDENT_VIEW_FROM_LIST_IN_PROGRESS',
    CLEAR_CONTENT = '@content/CLEAR_CONTENT',
    LAST_PUBLISHED_SUCCESS = '@content/LAST_PUBLISHED_SUCCESS',
    MOST_ACCESSED_SUCCESS = '@content/MOST_ACCESSED_SUCCESS',
    IN_PROGRESS_SUCCESS = '@content/IN_PROGRESS_SUCCESS',
    COMPLETED_SUCCESS = '@content/COMPLETED_SUCCESS',
    TOP_RATED_SUCCESS = '@content/TOP_RATED_SUCCESS',
    FAVORITES_SUCCESS = '@content/FAVORITES_SUCCESS',
    LIKE_YOU_SUCCESS = '@content/LIKE_YOU_SUCCESS',
    FOR_YOU_SUCCESS = '@content/FOR_YOU_SUCCESS',
    SUGGESTED_SUCCESS = '@content/SUGGESTED_SUCCESS',
    SEARCHED_SUCCESS = '@content/SEARCHED_SUCCESS',
    ESSENTIALS_SUCCESS = '@content/ESSENTIALS_SUCCESS',
    CLEAR_CONTENT_LIST = '@content/CLEAR_CONTENT_LIST',
    TOGGLE_ITEM_VISIBILITY_REQUEST = '@item/TOGGLE_ITEM_VISIBILITY_REQUEST',
    TOGGLE_ITEM_VISIBILITY_SUCCESS = '@item/TOGGLE_ITEM_VISIBILITY_SUCCESS',
    TOGGLE_ITEM_VISIBILITY_FAILURE = '@item/TOGGLE_ITEM_VISIBILITY_FAILURE',
    TOGGLE_ITEM_VISIBILITY_CLEAR = '@item/ARCHIVE_ITEM_CLEAR',
    ADD_LIST_BY_CATEGORY = '@content/ADD_LIST_BY_CATEGORY',
    CATEGORIZED_SUCCESS = '@content/CATEGORIZED_SUCCESS',
    UPDATE_CONTENT_STUDENT_VIEW_REQUEST = '@content/UPDATE_CONTENT_STUDENT_VIEW_REQUEST',
    UPDATE_CONTENT_STUDENT_VIEW_SUCCESS = '@content/UPDATE_CONTENT_STUDENT_VIEW_SUCCESS',
    UPDATE_CONTENT_STUDENT_VIEW_FAILURE = '@content/UPDATE_CONTENT_STUDENT_VIEW_FAILURE',
    REMOVE_CONTENT_FROM_LIST = '@content/REMOVE_CONTENT_FROM_LIST',
    SET_CURRENT_CONTENT = '@content/SET_CURRENT_CONTENT',
    SET_CONTENT_LINK_METADATA_REQUEST = '@content/SET_CONTENT_LINK_METADATA_REQUEST',
    SET_CONTENT_LINK_METADATA_SUCCESS = '@content/SET_CONTENT_LINK_METADATA_SUCCESS',
    SET_CONTENT_LINK_METADATA_FAILURE = '@content/SET_CONTENT_LINK_METADATA_FAILURE',
    CONTENTS_CLEAR = '@content/CONTENTS_CLEAR',
    CONTENTS_SEARCHED_CLEAR = '@content/CONTENTS_SEARCHED_CLEAR',
    CONTENTS_COMPLETED_CLEAR = '@content/CONTENTS_COMPLETED_CLEAR',
    INCREASE_TOTAL_SUGGESTED = '@content/INCREASE_TOTAL_SUGGESTED',
    DECREASE_TOTAL_SUGGESTED = '@content/DECREASE_TOTAL_SUGGESTED',
    TRAININGS_SUCCESS = '@content/TRAININGS_SUCCESS',
    TRAININGS_CLEAR = '@content/TRAININGS_CLEAR',
    REFRESH_ITEM = '@content/REFRESH_ITEM',
}

export interface Itens {
    itens: [Item];
    total: number;
}

export interface ItensState {
    data: Itens;
    loading: boolean;
    hasError: boolean;
    error?: AxiosError;
    refreshItem?: boolean;
    success: boolean;
    listData: {
        [key: string]: ListContentStudentViewData;
        listLastPublishedStudentView: ListContentStudentViewData;
        listMostAccessedStudentView: ListContentStudentViewData;
        listInProgressStudentView: ListContentStudentViewData;
        listCompletedStudentView: ListContentStudentViewData;
        listTopRatedStudentView: ListContentStudentViewData;
        listLikeYouStudentView: ListContentStudentViewData;
        listForYouStudentView: ListContentStudentViewData;
        listSearchResultStudentView: ListContentStudentViewData;
        listSuggestedStudentView: ListContentStudentViewData;
        listEssentialStudentView: ListContentStudentViewData;
        listTrainingsEnrolledStudentView: ListContentStudentViewData;
    };

    currentData: ContentStudentView;
}

export interface ContentStudentView {
    content: Item;
    contentEnrollment: ContentEnrollment;
}

export interface ListContentStudentViewData {
    list: ContentStudentView[];
    total: number;
    loading: boolean;
}

export interface ContentStudentViewRequest {
    contentId: number;
    personId: number;
    locale?: string;
}
